export default {
  columns: 'Kolumny',
  hasTotal: 'Suma',
  addColumn: 'Dodaj kolumnę',
  unknownAttribute: 'Usunięty atrybut',
};
